import { render, staticRenderFns } from "./PlayerRegistrationFormProfileCard.vue?vue&type=template&id=18767d81&scoped=true&"
import script from "./PlayerRegistrationFormProfileCard.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationFormProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistrationFormProfileCard.vue?vue&type=style&index=0&id=18767d81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18767d81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
